import script from "./privacyTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./privacyTerms.vue?vue&type=script&setup=true&lang=js"

import "./privacyTerms.vue?vue&type=style&index=0&id=799558a0&lang=css"
import "./privacyTerms.vue?vue&type=style&index=1&id=799558a0&lang=scss&scoped=true"

import exportComponent from "/root/yunxiao/be-oq3uli62ily0nz39bqi4ejzo/runner/__flow_work/__flow_builds/b53d412c-1e8a-456a-9c29-1ab66932d45e/workspace/h5s_4wZu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799558a0"]])

export default __exports__